const isCheckboxAndRadioMultiple = (node) => (node.props.type === "checkbox" || node.props.type === "radio") && node.props.options;
function addAsteriskPlugin(node) {
  node.on("created", () => {
    const isRequired = node.props.parsedRules.some((rule) => rule.name === "required");
    if (!isRequired)
      return;
    const isMultiOption = isCheckboxAndRadioMultiple(node);
    node.props.definition.schemaMemoKey = `required_${isMultiOption ? "multi_" : ""}${node.props.definition.schemaMemoKey}`;
    const schemaFn = node.props.definition.schema;
    node.props.definition.schema = (sectionsSchema = {}) => {
      if (isRequired) {
        if (isMultiOption) {
          sectionsSchema.legend = {
            children: ["$label", "*"]
          };
        } else {
          sectionsSchema.label = {
            children: ["$label", "*"]
          };
        }
      }
      return schemaFn(sectionsSchema);
    };
  });
}

export { addAsteriskPlugin as a };
//# sourceMappingURL=requiredAsterisk-DvcamZ9f.js.map
